import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useMemo } from 'react';
import moment from 'moment';
import { textTran } from 'eco-design/elements/eco-email/config';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

const contactListIds = {
    us: '1272859510',
    ca: '250347439',
};

function BannerEmailB() {
    const { locale = 'us' } = getLocal();
    const { t } = useLang('theProduct.BannerA');
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();

    const fields = useMemo(() => {
        const date = moment(systemTime).format('YYYY-MM-DD') as any;
        const NA_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: false },
            { type: 'multiple', id: '11150', value: [12], overwrite: false },
            { type: 'text', id: '12555', value: date, overwrite: false },
        ];
        switch (locale) {
            case 'us':
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
            case 'ca':
                return [{ type: 'single', id: '4424', value: 1, overwrite: true }, ...NA_Fields];
            default:
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
        }
    }, [locale, systemTime]);

    // 邮件
    const termsHtml = useMemo(() => {
        switch (locale) {
            case 'us':
            case 'ca':
                return `I consent to the <a href="https://${locale}.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-${locale}/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.`;
            default:
                return undefined;
        }
    }, [locale]);
    return (
        <div className="email-hot-box">
            <div className="email-hot-a">{t('discount')}</div>
            <EcoEmail
                contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.us]}
                source="WEB_NEW_PRODUCT_SUB"
                fields={fields}
                termsHtml={termsHtml}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: textTran[locale]?.btnText ?? textTran['us'].btnText,
                    product_name: 'EcoFlow WAVE 3',
                }}
                tipsObj={{
                    placeholder: t('placeholder'),
                    tipsCheck: t('tipsCheck'),
                    successTips: t('successTips'),
                }}
                needTerms
                subscribeData={{
                    sector_name: t('title'),
                    entry_position: 1,
                }}
            />
        </div>
    );
}
export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const { locale = 'us' } = getLocal();
    const IS_NA_SITE = ['us', 'ca'].includes(locale);

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1744680509885/kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1744339312408/kv_h5.jpg',
        label: t('label'),
        title: t('title'),
        subTitle: t('subTitle'),
        desc: t('desc'),
        childrenB: IS_NA_SITE ? <BannerEmailB /> : null,
        theme: 'white',

        lChildren: t('subscribe'),
        lHref: IS_NA_SITE ? '' : '#SectionB',
        lType: 'filled',

        rChildren: IS_NA_SITE ? '' : t('video'),
        rHref: IS_NA_SITE ? '' : '1',
        rBtnIsYouToBe: true,
        rType: 'outlined',
    };

    return (
        // @ts-ignore
        <div className={styles.comp} id="Banner">
            <EcoBanner {...dataA} />
        </div>
    );
}
